import { render, staticRenderFns } from "./h5.vue?vue&type=template&id=d2aaf952&scoped=true&"
import script from "./h5.vue?vue&type=script&lang=js&"
export * from "./h5.vue?vue&type=script&lang=js&"
import style0 from "./h5.vue?vue&type=style&index=0&id=d2aaf952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2aaf952",
  null
  
)

export default component.exports